module.exports = __webpack_public_path__ + "static/img/11.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/zh/11.png
// module id = qOOD
// module chunks = 0